import React from 'react';
import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { EventTemplates } from 'components/EventTemplates';
import { EVENT_TEMPLATE_OWNERS, EVENT_TEMPLATE_TARGETS } from 'constants/eventTemplate';

function DialogHistory({ open, handleClose, title, getEvents, historyId }) {
  const handleOnCloseDialog = (e, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
  };

  return (
    <Dialog open={open} onClose={handleOnCloseDialog} maxWidth="sm" fullWidth>
      {title && <DialogTitle id="dialog-title">{title}</DialogTitle>}
      <EventTemplates getEventList={getEvents} historyId={historyId} targets={[EVENT_TEMPLATE_TARGETS.DASHBOARD_APP]} owners={[EVENT_TEMPLATE_OWNERS.PREFIX_MANAGEMENT]} isWithoutSecond={false} />
      <DialogActions>
        <Button variant="contained" color="secondary" onClick={handleClose} startIcon={<CloseIcon />}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogHistory;
